import pic1 from '../images/pic1.jpg'
import pic2 from '../images/2.jpg'
import pic3 from '../images/3.jpg'
import pic4 from '../images/4.jpg'
import pic5 from '../images/5.jpg'
import pic6 from '../images/6.jpg'
import pic7 from '../images/7.jpg'
import pic8 from '../images/8.jpg'
import pic9 from '../images/9.jpg'
import pic10 from '../images/10.jpg'
export const items = [
	{
		id: 1,
		name: 'Product-1',
		price: 9.99,
		img: pic1,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['Black', 'DarkBlue', 'Blue', 'LightBlue'],
	},
	{
		id: 2,
		name: 'Product-2',
		price: 5.99,
		img: pic2,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['DarkRed', 'Maroon', 'FireBrick', 'Red', 'Crimson'],
	},
	{
		id: 3,
		name: 'Product-3',
		price: 19.99,
		img: pic3,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['SeaGreen', 'SpringGreen', 'Turquoise', 'Teal', 'SlateBlue', 'RoyalBlue'],
	},
	{
		id: 4,
		name: 'Product-4',
		price: 1.99,
		img: pic4,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['red', 'green', 'blue', 'orange'],
	},
	{
		id: 5,
		name: 'Product-5',
		price: 14.99,
		img: pic5,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['red', 'green', 'blue', 'orange'],
	},
	{
		id: 6,
		name: 'Product-6',
		price: 16.99,
		img: pic6,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['red', 'green', 'blue', 'orange'],
	},
	{
		id: 7,
		name: 'Product-7',
		price: 11.99,
		img: pic7,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['red', 'green', 'blue', 'orange'],
	},
	{
		id: 8,
		name: 'Product-8',
		price: 18.49,
		img: pic8,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['red', 'green', 'blue', 'orange'],
	},
	{
		id: 9,
		name: 'Product-9',
		price: 21.99,
		img: pic9,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['red', 'green', 'blue', 'orange'],
	},
	{
		id: 10,
		name: 'Product-10',
		price: 0.99,
		img: pic10,
		sizes: ['XS', 'S', 'M', 'L', 'XL'],
		colors: ['red', 'green', 'blue', 'orange'],
	}
]
